// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueTicket = (newValue) => ({
  type: actionTypes.SET_VALUE_TICKET,
  payload: newValue,
});

export const setEnCoursTicket = (newEnCours) => ({
  type: actionTypes.SET_EN_COURS_TICKET,
  payload: newEnCours,
});

export const setCorrigerTicket = (newValue) => ({
  type: actionTypes.SET_CORRIGER_TICKET,
  payload: newValue,
});

export const setLivreTicket = (livrer) => ({
  type: actionTypes.SET_LIVRE_TICKET,
  payload: livrer,
});

export const setEnAttenteValidationTicket = (data) => ({
  type: actionTypes.SET_EN_ATTENTE_VALIDATION_TICKET,
  payload: data,
});

export const setValideTicket = (data) => ({
  type: actionTypes.SET_VALIDE_TICKET,
  payload: data,
});

export const setACorrigerTicket = (data) => ({
  type: actionTypes.SET_A_CORRIGER_TICKET,
  payload: data,
});

export const setAnnulerTicket = (newAnnule) => ({
  type: actionTypes.SET_ANNULER_TICKET,
  payload: newAnnule,
});

export const setDateTicket = (newValue) => ({
  type: actionTypes.SET_DATE_TICKET,
  payload: newValue,
});
export const setTypeTicket = (newValue) => ({
  type: actionTypes.SET_TYPE_TICKET,
  payload: newValue,
});
export const setCriticiteTicket = (newValue) => ({
  type: actionTypes.SET_CRITICITE_TICKET,
  payload: newValue,
});
export const setStatutLivTicket = (newValue) => ({
  type: actionTypes.SET_STATUT_LIV_TICKET,
  payload: newValue,
});
export const setStatutReqTicket = (newValue) => ({
  type: actionTypes.SET_STATUT_REQ_TICKET,
  payload: newValue,
});
export const setCurrentPageTicket = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_TICKET,
  payload: newCurrentPage,
});
export const setSelectedOptionsTicket = (newSelectedOptions) => ({
  type: actionTypes.SET_SELECTED_OPTIONS_TICKET,
  payload: newSelectedOptions,
});
export const setSortFieldTicket = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_TICKET,
  payload: newSortField,
});
export const setOrderTicket = (newOrder) => ({
  type: actionTypes.SET_ORDER_TICKET,
  payload: newOrder,
});
